import React, { useEffect, useState } from 'react';
import { Box, Chip, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { TabIndices } from '@/common/i-doc/i-doc.registry.ts';
import { PageHint } from '@components/common/PageHint.tsx';
import { financeLegacyService, FinanceLegacyUser } from '@services/finance-legacy.service.ts';
import { toastService } from '@services/toast.service.ts';

// Список юзерів старого інтерфейсу (2026-08-21) - для майбутнього резолву
// created_user_id/emp_id в імена. Бек читає лише id/name/role/color -
// email/password/remember_token відсутні в самій User entity.
export const FinanceLegacyUsersTab: React.FC = () => {
  const [users, setUsers] = useState<FinanceLegacyUser[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    financeLegacyService.getUsers()
      .then(setUsers)
      .catch(() => toastService.error('Не вдалося завантажити юзерів.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box data-i-doc={TabIndices.DEV_FINANCE_LEGACY_USERS}>
      <PageHint iDoc={TabIndices.DEV_FINANCE_LEGACY_USERS} />

      {loading ? (
        <Box display="flex" justifyContent="center" sx={{ mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : users.length === 0 ? (
        <Typography sx={{ mt: 4, textAlign: 'center' }}>Юзерів не знайдено.</Typography>
      ) : (
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Імʼя</TableCell>
                <TableCell>Роль</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>{user.id}</TableCell>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>
                    {user.role ? <Chip label={user.role} size="small" variant="outlined" sx={{ borderColor: user.color ?? undefined, color: user.color ?? undefined }} /> : '—'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};
